import Select, { OptionSelected } from './Select';
import { createFilterOptions } from '@mui/material/Autocomplete';

const filter = createFilterOptions();

export interface SelectProps {
  onChange?: (value: object) => void;
  value?: object;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  options: OptionSelected[];
  defaultValue?: any;
  multi?: boolean | any;
  className: string;
  loading?: boolean;
  onInputChange?: (event: React.ChangeEvent) => void;
  mandatory: boolean;
  error?: string;
  filterOptions?: (options: any, params: any) => any;
}

export default class CreatableTest extends React.PureComponent<SelectProps, {}> {
  static defaultProps: SelectProps = {
    multi: false,
    options: [],
    className: '',
    mandatory: false,
  };

  render() {
    return (
      <Select
        {...{ ...this.props }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          if (params.inputValue !== '') {
            filtered.push({
              value: params.inputValue,
              label: `${window.Alfresco.messages.global['button.add']} "${params.inputValue}"`,
            });
          }

          return filtered;
        }}
        getOptionLabel={option => {
          if (!option) {
            return 'placeholder';
          }
          if (typeof option === 'string') {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.label;
        }}
        creatable={true}
      />
    );
  }
}
